var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinanceMode = function SvgFinanceMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "finance-mode_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 13.65V6h3v7.65l-1.5-1.4zm5 1.5V2h3v10.15zM2 18.6V10h3v5.6zm0 2.45 6.45-6.45L12 17.65l5.6-5.6H16v-2h5v5h-2v-1.6l-6.9 6.9-3.55-3.05-3.75 3.75z"
  })));
};
export { SvgFinanceMode as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNyAxMy42NVY2SDEwVjEzLjY1TDguNSAxMi4yNUw3IDEzLjY1Wk0xMiAxNS4xNVYySDE1VjEyLjE1TDEyIDE1LjE1Wk0yIDE4LjZWMTBINVYxNS42TDIgMTguNlpNMiAyMS4wNUw4LjQ1IDE0LjZMMTIgMTcuNjVMMTcuNiAxMi4wNUgxNlYxMC4wNUgyMVYxNS4wNUgxOVYxMy40NUwxMi4xIDIwLjM1TDguNTUgMTcuM0w0LjggMjEuMDVIMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";